(() => {
  if (window.lkQuickAddReady) return;
  window.lkQuickAddReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lk-review-direction]');
    if (!button) return;
    const track = Array.from(button.closest('section').querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body'))
      .find((element) => element.offsetWidth > 0 && getComputedStyle(element).display !== 'none');
    track?.scrollBy({left: Number(button.dataset.lkReviewDirection) * track.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-lk-quick-add]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[role="alert"]');
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.textContent = '';
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST', body: new FormData(form),
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || error.dataset.errorMessage);
      if (window.KompliceCartDrawer) {
        await window.KompliceCartDrawer.open();
      } else {
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
    } catch (failure) {
      error.textContent = failure.message || error.dataset.errorMessage;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
